(function () {
  'use strict';

  function init() {
    const stickyBar = document.getElementById('snsei-sticky-cart');
    const stickyBtn = document.getElementById('snsei-sticky-btn');
    const mainBtn   = document.querySelector('.product-form__submit');

    if (!stickyBar || !mainBtn) return;

    // Show/hide sticky bar when main button leaves viewport
    const observer = new IntersectionObserver(function (entries) {
      const visible = entries[0].isIntersecting;
      stickyBar.classList.toggle('snsei-sticky-cart--visible', !visible);
      stickyBar.setAttribute('aria-hidden', visible ? 'true' : 'false');
    }, { threshold: 0.1 });

    observer.observe(mainBtn);

    // Proxy click to main submit button
    stickyBtn && stickyBtn.addEventListener('click', function () {
      if (!mainBtn.disabled) mainBtn.click();
    });

    // Keep disabled state in sync (variant changes)
    function syncState() {
      if (!stickyBtn) return;
      stickyBtn.disabled = mainBtn.disabled;
      stickyBtn.textContent = mainBtn.disabled ? 'אזל מהמלאי' : 'הוסף לסל';
    }

    new MutationObserver(syncState).observe(mainBtn, { attributes: true, childList: true, subtree: true });
    syncState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
